import { useState } from 'react'

import { PlainCheckboxGroup } from 'app/common/ui-next/plain-checkbox'
import { useDataBoxSelector } from 'app/common/data-box-store'
import { orgsFilterSelection, schoolYearFilterSelection } from 'app/dataProviders/filter-items'

import { FinancesControlId } from '../../../common/financesCommonFilter/types'

const items = [
  {
    id: FinancesControlId.HideCorrectionPayments,
    title: 'Скрыть корректирующие платежи',
    defaultChecked: true,
  },
]

type Props = {
  id: FinancesControlId
  pending: boolean
}

export const HideCorrectionPayments = ({ id, pending }: Props) => {
  const [value, setValue] = useState<Array<string>>([])

  const orgsFilterSelectionData = useDataBoxSelector(orgsFilterSelection, () =>
    orgsFilterSelection.getData(),
  )
  const isOrgReady = orgsFilterSelectionData.length === 1 && orgsFilterSelectionData[0] !== 'empty'

  const [schoolYearId] = useDataBoxSelector(schoolYearFilterSelection, () =>
    schoolYearFilterSelection.getData(),
  )
  const isSchoolYearReady = !!schoolYearId

  return (
    isOrgReady &&
    isSchoolYearReady && (
      <PlainCheckboxGroup
        id={id}
        items={items}
        current={value}
        onValue={setValue}
        disabled={pending}
        keepPadding
      />
    )
  )
}
